import { makeStyles, Snackbar, SnackbarContent, Theme } from "@material-ui/core";
import { green }                                        from "@material-ui/core/colors";
import clsx                                             from "clsx";
import React, { FC, useEffect, useState }               from "react";
import { useDispatch, useStore }                        from "react-redux";
import Notify                                           from "../../../domain/fundamentals/message/notify/Notify";
import NotifyType                                       from "../../../domain/fundamentals/message/notify/NotifyType";
import { notifyInit }                                   from "../../../infrastructure/redux/notify/NotifyAction";

const NotifyDisplay: FC = () => {
  const notify: Notify = useStore().getState().notify;
  const dispatch = useDispatch();
  const classes = selectStyles();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!notify.message.isEmpty()) {
      setOpen(true);
      setTimeout(() => {
        dispatch(notifyInit());
        setOpen(false);
      }, 1000);
    }
  }, [notify]);

  return (
    <>
      <Snackbar
        open={ open }
        anchorOrigin={ {
          vertical: "bottom",
          horizontal: "right"
        } }
        autoHideDuration={ 1000 }
        onClose={ () => dispatch(notifyInit()) }
      >
        <SnackbarContent
          className={ clsx(classes[colorName(notify.type.value)]) }
          message={
            <>
            <span>
              { notify.message.value }
            </span>
            </>
          }
        />
      </Snackbar>
    </>
  );
};

const selectStyles = makeStyles((theme: Theme) => ({
  default: {
    backgroundColor: theme.palette.common.black,
  },
  success: {
    backgroundColor: green[600],
  },
  failure: {
    backgroundColor: theme.palette.error.dark,
  }
}));

const colorName = (type: NotifyType) => {
  switch (type) {
    default:
      return "default";
    case NotifyType.SAVE_SUCCESS:
    case NotifyType.DELETE_SUCCESS:
    case NotifyType.MAIL_SEND_SUCCESS:
    case NotifyType.OPTIONAL_SUCCESS:
      return "success";
    case NotifyType.SAVE_FAILURE:
    case NotifyType.DELETE_FAILURE:
    case NotifyType.FETCH_FAILURE:
    case NotifyType.OPTIONAL_FAILURE:
      return "failure";
  }
};

export default NotifyDisplay;
